<template>
  <section>
    <div class="flex flex-col sm:flex-row items-center mt-8 border-b border-gray-200">
        <h2 class="font-medium text-base mr-auto" v-if="team_session == 1">
          Trafico Mensual
        </h2>
        <h2 class="font-medium text-base mr-auto" v-else>
          Trafico Semanal
        </h2>
        <div class="w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0">
            <button @click="viewAccounts('all')" class="button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10" v-if="account_session">
              Ver todas las cuentas
            </button>
            <button @click="viewAccounts('one')" class="button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10" v-else>
              Ver solo una cuenta
            </button> &nbsp;
            <div class="mr-3">Fechas:</div>
            <button @click="changeWeek('minus')" class="button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10">
              <app-icon v-bind:name="'chevron-left'" v-bind:classname="'w-5'"></app-icon>
            </button>
            <button class="button mr-1 mb-2 mt-2 bg-theme-1 text-white courser-not">
              {{firstday.toISOString().slice(0,10)}} - {{lastday.toISOString().slice(0,10)}}
            </button>
            <button @click="changeWeek('plus')" class="button inline-flex button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10">
              <app-icon v-bind:name="'chevron-right'" v-bind:classname="'w-5'"></app-icon>
            </button>
        </div>
    </div>

    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6">
          <!-- Digital -->
          <div class="col-span-12" v-if="team_session == 1">
            <div class="intro-y box mt-4 p-2">
              <div v-for="project in projects" :key="project.id">
                <div v-if="sum.project_id == project.id && project.hours > 1" v-for="sum in sumHoursByProject">
                    <div class="flex bg-red-200 rounded-lg p-4 mb-2 text-sm text-red-700" role="alert" v-if="project.hours-sum.total < 0">
                        <svg class="w-5 h-5 inline mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clip-rule="evenodd">
                          </path>
                        </svg>
                        <div>
                            <span class="font-medium">{{ project.name }} - {{project.account.name}} - {{project.account.country.prefix}}</span> excedió el número de horas asignadas.
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="intro-y box mt-1" v-for="project in projects" v-if="project.account_id == account_session || account_session == null">
                <div class="flex flex-col sm:flex-row items-center p-5 mt-8 border-b border-gray-200">
                    <h2 class="font-medium text-base mr-auto" :class="[
                      project.hours > 1
                        ? 'text-theme-1'
                        : '',
                    ]">
                      {{project.name}} - {{project.account.name}} - {{project.account.country.prefix}}
                    </h2>
                    <div class="w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0">
                      <button class="button button--sm mr-1 mb-2 mt-2 border dark:border-dark-5 dark:text-gray-300 courser-not">
                         <span v-if="sum.project_id == project.id" v-for="sum in sumHoursByProject">
                           <span>{{project.hours-sum.total | two_decimal}}</span>
                         </span>
                         Horas Disponibles
                      </button>
                      <button class="button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10 courser-not">
                         <span v-if="sum.project_id == project.id" v-for="sum in sumHoursByProject">{{sum.total | two_decimal}}</span> /
                         <span v-if="project.id">{{project.hours | two_decimal}}</span> Horas
                      </button>
                    </div>
                </div>
                <div class="p-5" id="bordered-table">
                    <div class="preview">
                        <div class="overflow-x-auto">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="border border-b-2 dark:border-dark-5 whitespace-nowrap">Nombre</th>
                                        <th class="border border-b-2 dark:border-dark-5 whitespace-nowrap">Asignada a</th>
                                        <th class="border border-b-2 dark:border-dark-5 whitespace-nowrap">No. Horas</th>
                                        <th class="border border-b-2 dark:border-dark-5 whitespace-nowrap">Fecha Entrega</th>
                                        <th class="border border-b-2 dark:border-dark-5 whitespace-nowrap">Estado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="task in filteredTasks" v-if="task.project_id == project.id"
                                      :class="{'tr-green' : task.state_id == 4}">
                                        <td class="border">{{task.name}}</td>
                                        <td class="border"><span v-if="task.user_id">{{task.user_name}}</span></td>
                                        <td class="border">{{task.hours}}</td>
                                        <td class="border"><button class="button button--sm w-24 text-white" :class="dateClass(task)">{{task.date}}</button></td>
                                        <td class="border">{{task.state_name}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
              </div>
          </div>

        <!-- other teams -->
        <div class="col-span-12" v-else>
          <div class="intro-y box p-2 mt-4">
            <div v-for="account in user.accounts" :key="account.id">
              <span v-if="sum.account_id == account.id" v-for="sum in sumHoursByAccount">
                <span v-if="hour.account_id == account.id" v-for="hour in filteredHours">
                  <div class="flex bg-red-200 rounded-lg p-4 mb-2 text-sm text-red-700" role="alert" v-if="hour.hours-sum.total < 0">
                      <svg class="w-5 h-5 inline mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clip-rule="evenodd">
                        </path>
                      </svg>
                      <div>
                          <span class="font-medium">{{ account.name }} - {{account.country.prefix}}</span> excedió el número de horas asignadas.
                      </div>
                  </div>
                </span>
              </span>
            </div>
          </div>
          <div class="intro-y box mt-1" v-for="account in user.accounts" v-if="account.id == account_session || account_session == null">
              <div class="flex flex-col sm:flex-row items-center p-5 mt-8 border-b border-gray-200">
                  <h2 class="font-medium text-base mr-auto">
                    {{account.name}} - {{account.country.prefix}}
                  </h2>
                  <div class="w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0">
                    <button class="button button--sm mr-1 mb-2 mt-2 border dark:border-dark-5 dark:text-gray-300 courser-not">
                       <span v-if="sum.account_id == account.id" v-for="sum in sumHoursByAccount">
                         <span v-if="hour.account_id == account.id" v-for="hour in filteredHours">{{hour.hours-sum.total | two_decimal}}</span>
                       </span>
                       Horas Disponibles
                    </button>
                    <button class="button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10 courser-not">
                       <span v-if="sum.account_id == account.id" v-for="sum in sumHoursByAccount">{{sum.total | two_decimal}}</span> /
                       <span v-if="hour.account_id == account.id" v-for="hour in filteredHours">{{hour.hours | two_decimal}}</span> Horas
                    </button>
                    <button class="button button--sm mr-1 mb-2 mt-2 border  dark:border-dark-5 dark:text-gray-300 courser-not">
                       <span v-if="hour.account_id == account.id" v-for="hour in filteredHours">{{(hour.hours)/5 | two_decimal}}</span> Diarias
                    </button>
                  </div>
              </div>
              <div class="p-5" id="bordered-table">
                  <div class="preview">
                      <div class="overflow-x-auto">
                          <table class="table">
                              <thead>
                                  <tr>
                                      <th class="border border-b-2 dark:border-dark-5 whitespace-nowrap">Nombre</th>
                                      <th class="border border-b-2 dark:border-dark-5 whitespace-nowrap">Estado</th>
                                      <th class="border border-b-2 dark:border-dark-5 whitespace-nowrap">No. Horas</th>
                                      <th class="border border-b-2 dark:border-dark-5 whitespace-nowrap">Fecha Entrega</th>
                                      <th class="border border-b-2 dark:border-dark-5 whitespace-nowrap">Acciones</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="task in filteredTasks" v-if="task.campaign_attribute.project_account_id == account.id"
                                    :class="{'tr-green' : task.state_id == 4}">
                                      <td class="border">{{task.name | limit}}</td>
                                      <td class="border">
                                        {{task.state_name}} <br>
                                        <span v-if="task.user_id">{{task.user_name}}</span>
                                      </td>
                                      <td class="border">{{task.hours}}</td>
                                      <td class="border"><button class="button button--sm w-24 text-white" :class="dateClass(task)">{{task.date}}</button></td>
                                      <td class="border">
                                        <a @click="viewAccountTask(task)" class="cursor-pointer flex items-center mr-3"
                                          v-if="task.state_id != 4">
                                          <app-icon name="edit" classname="w-4 h-4 mr-2"></app-icon> Editar
                                        </a>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
            </div>
          </div>


      </div>
    </div>

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'

import { handleDateClass } from '@/services/DateClass'
import { todayFormat } from '@/services/TodayFormat'

export default {
  name: 'Week',
  data () {
    return {
      loading: false,
      firstday: null,
      lastday: null,
      account_session: null,
      team_session: null,
      projects: null,
      today: null,
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      tasks: 'getTasks',
      hours: 'getHours'
    }),
    filteredTasks: function() {
      return this.tasks.filter((item) => {
        if(item.date >= this.firstday.toISOString().slice(0,10)
          && item.date <= this.lastday.toISOString().slice(0,10))
        {
          return item;
        }
      })
    },
    filteredHours: function() {
      return this.hours.filter((item) => {
        if(item.team_id == localStorage.session_team)
        {
          return item;
        }
      })
    },
    sumHoursByProject: function() {
      var arr = [];
      this.tasks.filter((item) => {
        if(item.date >= this.firstday.toISOString().slice(0,10)
          && item.date <= this.lastday.toISOString().slice(0,10))
        {
          var row = {
            project_id: item.project_id,
            total: item.hours
          };
          arr.push(row);
        }
      })

      const res = Array.from(arr.reduce(
        (m, {project_id, total}) => m.set(project_id, (m.get(project_id) || 0) + total), new Map
      ), ([project_id, total]) => ({project_id, total}));

      return res;
    },
    sumHoursByAccount: function() {
      var arr = [];
      this.tasks.filter((item) => {
        if(item.team_id == localStorage.session_team && item.date >= this.firstday.toISOString().slice(0,10)
          && item.date <= this.lastday.toISOString().slice(0,10))
        {
          var row = {
            account_id: item.campaign_attribute.project_account_id,
            total: item.hours
          };
          arr.push(row);
        }

      })

      const res = Array.from(arr.reduce(
        (m, {account_id, total}) => m.set(account_id, (m.get(account_id) || 0) + total), new Map
      ), ([account_id, total]) => ({account_id, total}));

      return res;
    }
  },
  async beforeMount () {
    this.account_session = null;
    this.team_session = localStorage.session_team;

    this.week()

    //SEND ENTITY AND MUTATION
    let query = `account_session=${this.user.accountsIds}&team_session=${this.team_session}&states=all`
    let query_projects = `account_session=${this.user.accountsIds}&hours=true`

    try {
      await this.getListTasksMongo(['task', query])
      await this.getList(['project',query_projects]).then(item => {
        this.projects = item.list
      })
      .catch(message => {
        this.$router.replace(this.$route.query.redirect || '/')
      })
      this.getAll('hour')

      this.loading = true
    } catch (error) {}
  },
  mounted() {
      let newDate = new Date()
      let dd = newDate.getDate()
      let mm = newDate.getMonth() + 1
      let yyyy = newDate.getFullYear()

      this.today = todayFormat()
  },
  methods: {
    ...mapActions([
      'getListTasksMongo',
      'getList',
      'getAll'
    ]),
    week () {
      var curr = new Date;

      if(this.team_session == 1) {
        this.firstday = new Date(curr.getFullYear(), curr.getMonth(), 1);
        this.lastday = new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
      } else {
        this.firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()+1));
        this.lastday = new Date(curr.setDate(curr.getDate() - curr.getDay()+5));
      }
    },
    viewAccounts (val) {
      let query = ''

      if(val == 'all') {
        query = `account_session=${this.user.accountsIds}&team_session=${this.team_session}&states=all`
        this.account_session = null
      } else {
        this.account_session = localStorage.session_account
        query = `account_session=${localStorage.session_account}&team_session=${this.team_session}&states=all`
      }

      try {
        this.getListTasksMongo(['task', query])

        this.loading = true
      } catch (error) {}
    },
    viewAccountTask(task) {
      localStorage.session_account = task.campaign_attribute.project_account_id;
      this.$router.push({ path: '/admin/tasks?task='+task.id+'account='+task.campaign_attribute.project_account_id })
    },
    changeWeek (val) {
      var curr = new Date(this.firstday);

      if(this.team_session == 1) {
        if(val == 'minus') {
          this.firstday = new Date(curr.getFullYear(), curr.getMonth() - 1);
          var new_date =  new Date(this.firstday);
          this.lastday = new Date(new_date.getFullYear(), new_date.getMonth() + 1, 0);
        } else {
          this.firstday = new Date(curr.getFullYear(), curr.getMonth() + 1);
          var new_date =  new Date(this.firstday);
          this.lastday = new Date(new_date.getFullYear(), new_date.getMonth() + 1, 0);
        }
      } else {
        if(val == 'minus') {
          this.firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()-6));
          this.lastday = new Date(curr.setDate(curr.getDate() - curr.getDay()+5));
        } else {
          this.firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()+8));
          this.lastday = new Date(curr.setDate(curr.getDate() - curr.getDay()+5));
        }
      }
    },
    dateClass(task) {
      return handleDateClass('task', task, this.today)
    },
  },
  components: {
    appIcon: Icon,
    handleDateClass,
    todayFormat
  }

}
</script>



// WEBPACK FOOTER //
// Week.vue?411ea24f